import { render, staticRenderFns } from "./work_item_create_branch_merge_request_split_button.vue.js?vue&type=template&id=6c3fa9d2!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_create_branch_merge_request_split_button.vue?vue&type=template&id=6c3fa9d2"
import script from "./work_item_create_branch_merge_request_split_button.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_create_branch_merge_request_split_button.vue?vue&type=script&lang=js"
export * from "./work_item_create_branch_merge_request_split_button.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_create_branch_merge_request_split_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports